import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function validIntId(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(+control.value <= 0)
            return { validIntId: true };

        return null;
    };
}

export function requiredIfTrue(value: () => boolean): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(value() && (control.value === undefined || control.value === null || control.value === ''))
            return { requiredIfTrue: true };

        return null;
    };
}

export function requiredIfFalse(value: () => boolean): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(!value() && (control.value === undefined || control.value === null || control.value === ''))
            return { requiredIfFalse: true };

        return null;
    };
}

export function requiredIf(value: () => boolean): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(value() && (control.value === undefined || control.value === null || control.value === ''))
            return { requiredIf: true };

        return null;
    };
}

export function passwordsAreEquals(value: () => string): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(!value() || (control.value !== value()))
            return { passwordsAreEquals: true };

        return null;
    };
}



export function validCpf(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if(control.value === null || control.value === '' || control.value === undefined)
            return null;

        let cpf = control.value.replace(/\D/g, '');

        if(cpf.length !== 11)
            return { validCpf: true };

        if(cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' ||
            cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' ||
            cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' ||
            cpf === '99999999999')
            return { validCpf: true };

        let add = 0;
        for(let i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if(rev === 10 || rev === 11)
            rev = 0;
        if(rev !== parseInt(cpf.charAt(9)))
            return { validCpf: true };

        add = 0;
        for(let i = 0; i < 10; i++)
            add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if(rev === 10 || rev === 11)
            rev = 0;
        if(rev !== parseInt(cpf.charAt(10)))
            return { validCpf: true };

        return null;
    };
}
































